import { ShieldCheck } from 'lucide-react';
import type { ChangeOrder } from '../../types';

export function isInternallyApprovedChangeOrder(
  co: Pick<ChangeOrder, 'internalApproval' | 'signature'>,
): boolean {
  return Boolean(co.internalApproval && !co.signature);
}

interface ChangeOrderInternalBadgeProps {
  recordedBy?: string;
  className?: string;
  size?: 'sm' | 'md';
}

export default function ChangeOrderInternalBadge({
  recordedBy,
  className = '',
  size = 'sm',
}: ChangeOrderInternalBadgeProps) {
  const title = recordedBy
    ? `Approved internally by ${recordedBy} — no client signature on file`
    : 'Approved internally — no client signature on file';

  return (
    <span
      className={`co-internal-badge co-internal-badge--${size}${className ? ` ${className}` : ''}`}
      title={title}
    >
      <ShieldCheck size={size === 'sm' ? 11 : 13} strokeWidth={2.25} aria-hidden />
      <span>Internal</span>
    </span>
  );
}
